const Config = {
  aws_appsync_region: process.env.GATSBY_APPSYNC_REGION, // (optional) - AWS AppSync region
  aws_appsync_graphqlEndpoint: process.env.GATSBY_APPSYNC_GRAPHQL_ENDPOINT, // (optional) - AWS AppSync endpoint
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS', // (optional) - Primary AWS AppSync authentication type
};

export { Config };